import { User } from 'types';
import { isTablet, useNavigate } from 'hooks';
import { TabletAlign } from 'pages/employees/list/styles';
import { Flex, Avatar, ListCard, EllipsisText } from 'components';
import { DeactivatedBadge } from 'pages/employees/deactivated-badge';

import { titles, template, cellsMobile, tabletTemplate } from './config';

export const Card = ({ data }: { data: User }) => {
  const navigate = useNavigate();
  const tablet = isTablet();

  const card = (
    <ListCard
      headers={titles}
      template={template}
      cellsMobile={cellsMobile}
      tabletTemplate={tabletTemplate}
      onClick={() => navigate(String(data.id))}
      verticalAlign={tablet ? 'flex-start' : 'center'}
      values={[
        <Flex gap={16} alignItems="center">
          <Avatar size={56} url={data.photoUrl} />
          <Flex gap={8} minWidth={0} alignItems="center">
            <EllipsisText>{data.name}</EllipsisText>
            <DeactivatedBadge
              compact
              hideDate
              deactivatedAt={data.deactivatedAt}
            />
          </Flex>
        </Flex>,
        data.email,
        data.company?.name,
        data.role?.name,
      ]}
    />
  );

  return tablet ? <TabletAlign>{card}</TabletAlign> : card;
};
